import React from 'react';
import { motion } from 'framer-motion';
import { Trophy } from 'lucide-react';
import { bonusIcons } from './BonusIllustrations';
const bonos = [{
  num: 'B1',
  title: 'EL CUADERNO DEL CAPITÁN',
  desc: 'Liderazgo y comunicación táctica para ser referente del equipo.',
  value: '$8.990'
}, {
  num: 'B2',
  title: 'DIARIO DEL JUGADOR',
  desc: 'Sistema de seguimiento + autoevaluación post-partido lista para usar.',
  value: '$6.990'
}, {
  num: 'B3',
  title: 'SCOUTING RIVAL',
  desc: 'Estudiá al equipo del sábado como profesional. Ficha lista para imprimir.',
  value: '$7.990'
}, {
  num: 'B4',
  title: 'INJURY FREE',
  desc: 'Protocolo anti-lesiones para no bajar en plena temporada.',
  value: '$9.990'
}, {
  num: 'B5',
  title: 'EL RUGBIER COMPLETO',
  desc: 'Habilidades individuales que los DT buscan: offload, footwork, juego aéreo.',
  value: '$7.990'
}, {
  num: 'B6',
  title: 'DE CLUB A PUMAS',
  desc: 'La hoja de ruta concreta para subir de nivel en el rugby argentino.',
  value: '$11.990'
}];
export function Bonos() {
  return <section className="py-14 md:py-24 bg-rugby-green-900 relative" data-id="element-38">
      <div className="absolute inset-0 bg-gradient-to-b from-rugby-green-950 to-transparent h-32" data-id="element-39" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-40">
        <div className="max-w-6xl mx-auto" data-id="element-41">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-6 md:mb-12" data-id="element-42">
            <span className="inline-block py-1 px-3 rounded-full bg-rugby-gold-500/10 text-rugby-gold-400 text-xs md:text-sm font-bold tracking-widest uppercase mb-3 md:mb-4 border border-rugby-gold-500/30" data-id="element-43">
              Incluidos Gratis
            </span>
            <h2 className="text-3xl md:text-5xl font-display text-white mb-2 md:mb-4" data-id="element-44">
              6 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-base md:text-xl text-slate-300 px-2" data-id="element-45">
              Sin costo extra — incluidos en todas las ofertas
            </p>
          </motion.div>

          {/* Compact grid: 2 cols on mobile, 3 on desktop */}
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-4 mb-6 md:mb-12" data-id="element-46">
            {bonos.map((bono, i) => {
            const Icon = bonusIcons[i];
            return <motion.div key={i} initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.06
            }} whileHover={{
              y: -3,
              transition: {
                duration: 0.2
              }
            }} className="bg-rugby-green-950 border border-rugby-green-700 rounded-xl p-3 md:p-4 relative overflow-hidden group hover:border-rugby-gold-500/50 transition-colors" data-id="element-47">
                  {/* GRATIS badge */}
                  <div className="absolute top-0 right-0 bg-rugby-gold-500 text-rugby-green-950 text-[9px] md:text-[10px] font-bold px-1.5 md:px-2 py-0.5 rounded-bl-md uppercase tracking-wider" data-id="element-48">
                    Gratis
                  </div>

                  {/* Illustration + Number row */}
                  <div className="flex items-start gap-2 md:gap-3 mb-2 md:mb-3" data-id="element-49">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex-shrink-0" data-id="element-50">
                      <Icon data-id="element-51" />
                    </div>
                    <div className="flex flex-col min-w-0 mt-0.5" data-id="element-52">
                      <span className="text-rugby-gold-400 font-display text-sm md:text-base leading-none" data-id="element-53">
                        {bono.num}
                      </span>
                      <h3 className="text-[11px] md:text-sm font-bold text-white leading-tight mt-1 pr-8 md:pr-10" data-id="element-54">
                        {bono.title}
                      </h3>
                    </div>
                  </div>

                  {/* Description */}
                  <p className="text-slate-400 text-[10px] md:text-xs leading-snug mb-2 md:mb-3 line-clamp-3" data-id="element-55">
                    {bono.desc}
                  </p>

                  {/* Value strip */}
                  <div className="pt-2 md:pt-3 border-t border-rugby-green-800 flex justify-between items-center" data-id="element-56">
                    <span className="text-slate-500 text-[10px] md:text-xs" data-id="element-57">
                      Valor
                    </span>
                    <span className="text-slate-300 line-through font-medium text-xs md:text-sm" data-id="element-58">
                      {bono.value}
                    </span>
                  </div>
                </motion.div>;
          })}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-r from-rugby-green-800 via-rugby-green-700 to-rugby-green-800 p-4 md:p-8 rounded-2xl border border-rugby-gold-500/30 text-center shadow-[0_0_30px_rgba(212,175,55,0.15)]" data-id="element-59">
            <div className="flex justify-center mb-2 md:mb-4" data-id="element-60">
              <Trophy size={28} className="text-rugby-gold-400 md:w-9 md:h-9" data-id="element-61" />
            </div>
            <h3 className="text-base md:text-3xl font-display text-white mb-1 md:mb-2" data-id="element-62">
              VALOR TOTAL:{' '}
              <span className="line-through text-slate-400 ml-1 md:ml-2" data-id="element-63">
                $53.940
              </span>
            </h3>
            <p className="text-xl md:text-4xl font-display text-rugby-gold-400 text-glow" data-id="element-64">
              HOY GRATIS
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}